// extracted by mini-css-extract-plugin
module.exports = {"home_footer":"FooterBar_home_footer__28ASQ","home_footer_div":"FooterBar_home_footer_div__2faaC"};